import _ from 'lodash';
import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanFeeCredits = createSelector(
  selectLoanApplication,
  ({ loanFeeCredits }) => loanFeeCredits?.credits || [],
);

export const selectLoanFeeCreditsByFeeTypeId = createSelector(selectLoanFeeCredits, credits =>
  _.groupBy(credits, 'feeTypeId'),
);
